import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import ApiRequest from '../../helper/ApiRequest';
import { ApiEndpoints } from '../../helper/ApiEndpoints';
import { BaseUrl } from '../../helper/BaseUrl';
import Breadcrumb from '../../../component/Breadcrumb';

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 1500,
  autoplaySpeed: 3500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  pauseOnHover: true,
  cssEase: "ease",
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        centerMode: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        centerMode: false,
      },
    },
  ],
};

const adminCaseListEndpoint = ApiEndpoints.caseCategory.caseCategoryList;

const breadcrumbData = {
  newClass:"white-breadcrumb center-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Case Study",
      slug:"/case-study"
    }
  ]
}

export default function CaseNewHead() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", adminCaseListEndpoint);
        const result = response.casestudy_categories;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, []);

  return (
    <>
      <section className="casenew-head-area header-gap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <Breadcrumb breadcrumbData={breadcrumbData}/>
            </div>
            <div className="col-lg-10">
              <h1 className="heading center-heading">Inspiring Stories, Real Mobility Infotech Customers</h1>
              <p className="sub-heading">See how our innovative mobility solutions helped brands streamline workflows, cut costs, and boost performance.</p>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="casenew-slider-wrap">
              <label>Featured Categories</label>
              <Slider {...settings}>
                {data && data?.map((slide)=>(
                  <div key={slide?._id} className="casenew-head-box">
                  <span>{slide?.name}</span>
                  <img src={BaseUrl + slide?.image} alt={slide?.alt_image} className="img-responsive" />
                </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
